import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { WidgetBoxComponent } from '../../widgets/box/box.component';
import { WidgetOptionComponent } from '../../widgets/option/option.component';
import { StateHelper } from '../../helpers/state.helper';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  imports: [
    CommonModule,
    WidgetBoxComponent,
    WidgetOptionComponent,
  ]
})
export class AppMenuComponent {

  /**
   * State helper
   */
  state_helper = inject(StateHelper);

  /**
   * Current page
   */
  page = computed(() => this.state_helper.page());

  /**
   * Menu details
   */
  menu = computed(() => [
    {
      name: 'Kyovy Games',
      description: 'Enjoy fresh collection of blockchain games',
      routes: [
        {
          id: 'games/tidal',
          name: 'Tidal Trader',
        },
        {
          id: 'games/metal',
          name: 'Metal Master',
        },
      ],
    },
    {
      name: 'Kyovy Tools',
      description: 'Explore rich ecosystem of exciting features',
      routes: [
        {
          id: 'tools/cycle',
          name: 'Staking Rewards',
        },
        {
          id: 'tools/dicer',
          name: 'Token Dicer',
        },
      ],
    }
  ]);

  /**
   * Construct component
   */
  constructor(
    private router: Router
  ) { }

  /**
   * Navigate to page
   * 
   * @param page
   */
  navigateToPage(page: string) {
    this.router.navigateByUrl(page);
  }
}
